export default function PreviewExerciserNotFoundError() {
    // Used in PreviewExerciserManager to display text when
    // requested exerciser is not found

    // BUILD
    return (
        <div className={"w-full h-full flex flex-col justify-center items-center"}>
            {"Exerciser not found"}
        </div>
    );
}